import React from 'react'
import { useContent } from '../../services'
import Aboutsec from '../Menabout/Aboutsec'
import Aboutservice from '../Menabout/Aboutservice'
import Aboutwhyus from '../Menabout/Aboutwhyus'
import Sliderabout from '../Menabout/Sliderabout'
import Testimonialsabout from '../Menabout/Testimonialsabout'
import Winningchef from '../Menabout/Winningchef'
import Bredcrumb from '../Bredcrumb/Main'
import PageSEO from '../SEO/PageSEO'
import Img from '../../assets/images/background/banner-image-1.jpg'

const BREADCRUMB_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.huqup380.com/' },
    { '@type': 'ListItem', position: 2, name: 'About', item: 'https://www.huqup380.com/about' }
  ]
}

function Main() {
  const { data, loading } = useContent('aboutContent');

  if (loading || !data) return null;

  const { breadcrumb } = data;

  return (
    <>
      <PageSEO
        title="About Us"
        description="Learn the story behind Huq Up - Cafe & Grill in Little Elm, TX — bold flavors, family recipes, and a passion for community. Open daily from 11 AM."
        canonical="https://www.huqup380.com/about"
        structuredData={BREADCRUMB_SCHEMA}
      />
      <Bredcrumb subtitle={breadcrumb.subtitle} title={breadcrumb.title} Img={Img} />
      <Aboutsec />
      <Winningchef />
      <Aboutservice />
      <Testimonialsabout />
      <Aboutwhyus />
      <Sliderabout />
    </>
  )
}
export default Main
